import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Importa BrowserRouter
// Axios
import axios from 'axios';
import { Chart, registerables } from 'chart.js';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
// Apps
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n';
import './_metronic/assets/fonticon/fonticon.css';
import './_metronic/assets/keenicons/duotone/style.css';
import './_metronic/assets/keenicons/outline/style.css';
import './_metronic/assets/keenicons/solid/style.css';
import './_metronic/assets/sass/style.scss';
import './_metronic/assets/sass/plugins.scss';
import './_metronic/assets/sass/style.react.scss';
import { AppRoutes } from './app/routing/AppRoutes';
import { AuthProvider, setupAxios } from './app/modules/auth';
import './_metronic/assets/new/NewStyle.css';
import './_metronic/assets/new/DarkMode.css';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { Auth0Provider } from '@auth0/auth0-react';

setupAxios(axios); // Configurar Axios para incluir el token
Chart.register(...registerables);

const queryClient = new QueryClient();
const container = document.getElementById('root');

// Interfaz de AppState para TypeScript
interface AppState {
  returnTo?: string;
}

// Configuración de Auth0
const domain = process.env.REACT_APP_AUTH0_DOMAIN || '';
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
const audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';

// const domain = 'dev-cfgo3rg1bhepln78.us.auth0.com';
// const clientId = 't9EnVreMgC2DDdH7wgH1TUQdAuCljpbM';
// const audience = 'https://stg-api.transitxchange.cloud';

// Redirección sin usar history
const onRedirectCallback = (appState: AppState | undefined) => {
  window.location.href = appState?.returnTo || '/redirecting';
};

const providerConfig = {
  domain: domain,
  clientId: clientId,
  onRedirectCallback,
  authorizationParams: {
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    audience: audience,
  },
};

// Render de la aplicación con Auth0Provider y BrowserRouter
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <MetronicI18nProvider>
          <Auth0Provider {...providerConfig} cacheLocation="localstorage">
            <AuthProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </AuthProvider>
          </Auth0Provider>
        </MetronicI18nProvider>
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
